<template>
<MainLayout>
    <div class="bg-gray-200 text-sm">
        <div class="container-fluid">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb mb-0 py-3">
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <li class="breadcrumb-item"><a class="fw-light" href="{{ route('home') }}">Winckieel</a></li>
                    <li class="breadcrumb-item"><a class="fw-light" href="{{ route('home') }}">Silos/armazéns</a></li>
                    <li class="breadcrumb-item"><a class="fw-light" href="{{ route('home') }}">Relatórios</a></li>
                    <li class="breadcrumb-item active fw-light" aria-current="page">Termometria</li>
                </ol>
            </nav>
        </div>
    </div>
    <header class="py-1">
        <div class="container-fluid py-2"></div>
    </header>
    <section class="pb-5 min-h-85">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-header card-header-v2 display-space-3"
            style="display: flex; justify-content: space-between; padding: 14pt">
                            <h3 class="h4 mb-0">Relatório da Termometria dos silos/armazéns: </h3>
                        </div>
                        <div class="card-body">
                            <p class="text-sm">Selecione as informações abaixo:</p>
                                <div class="row">
                                    <div class="col-sm-3">
                                        <label class="col-sm-12 form-label">Selecione os silos/armazéns: </label>
                                        <div class="row">
                                            <div>
                                                <div v-for="silo in silos" :key="silo.id" class="form-check">
                                                    <input 
                                                        class="form-check-input input-locais-checkbox"
                                                        :id="silo.id" 
                                                        :value="silo.id" 
                                                        type="radio"
                                                        name="local"
                                                        v-model="selectedSilo"
                                                    >
                                                    <label class="form-check-label" :for="silo.id">{{ silo.nome }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="form-label" for="data_inicio">Data início: </label>
                                        <input class="form-control" id="data_inicio" name="data_inicio" type="date"
                                            v-model="dataInicio">
                                    </div>
                                    <div class="col-sm-3">
                                        <label class="form-label" for="data_final">Data final: </label>
                                        <input class="form-control" id="data_final" name="data_final" type="date"
                                            v-model="dataFinal">
                                    </div>
                                    <div class="col-sm-2">
                                        <label class="form-label" for="data_inicio">&nbsp;</label>
                                        <div>
                                            <button class="btn btn-primary btn-view-relatorio" @click="fetchLeiturasBySilo">Buscar Leituras</button>
                                        </div>
                                    </div>
                                <p v-if="buscandoLeituras">Buscando leituras...</p>
                                    <div v-if="leiturasEncontradas.length > 0" class="row" id="leituras_result">
                                        <hr>
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <label class="form-label" for="leitura">Leituras encontradas:</label>
                                                <select class="form-control" name="leitura" id="leituras" v-model="selectedLeitura">
                                                    <option v-for="leitura in leiturasEncontradas" :key="leitura._id" :value="leitura._id">{{ leitura.data }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <hr>
                                                <div class="form-check">
                                                    <input class="form-check-input" id="colorido" name="colorido" value="1" 
                                                        type="checkbox" v-model="mostrarLeituraColorida">
                                                    <label class="form-check-label" for="colorido">Mostrar leitura colorida</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label class="form-label" for="data_inicio">&nbsp;</label>
                                            <div>
                                                <button @click="gerarRelatorio" class="btn btn-primary  btn-view-relatorio" id="viewRelatorio" type="button">Visualizar relatório</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            <hr>
                            &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <LoadingRelatorio v-if="loadingDados" />
                <div v-if="leituraData > []" class="col-lg-12">
                    <div class="card">
                        <div class="card-body container-relatorio table-responsive" id="tableReport" style="margin: 10px">
                            <div>
                                <div class="header-table">
                                    <h2 class="title-pdf">Relatório de Termometria</h2>
                                    <span>Sistema de gerenciamento cloud</span>
                                    <div style="margin: 25px; margin-bottom: 40px">
                                        <h3 class="header-unidade">
                                            Unidade: {{ unidade.nome }}
                                        </h3>
                                    </div>
                                </div>
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th colspan="17" style="padding: 12px; text-transform: uppercase;">
                                                {{ selectedSiloNome }}
                                            </th>
                                        </tr>
                                        <tr>
                                            <th colspan="17" style="padding: 12px; text-transform: uppercase;">
                                                Dados Meteorológicos
                                            </th>
                                        </tr>
                                        <tr v-if="leituraData && leituraData.estacao">
                                            <th colspan="3">Temperatura:</th>
                                            <th colspan="2">{{ leituraData.estacao.temperatura }} ºC</th>
                                            <th colspan="3">Umidade:</th>
                                            <th colspan="3">{{ leituraData.estacao.umidade }} %</th>
                                            <th colspan="3">Chuva:</th>
                                            <th colspan="3">{{ leituraData.estacao.chuva ? 'SIM' : 'NÃO' }}</th>
                                        </tr>
                                        <tr>
                                            <th colspan="17" style="padding: 12px; text-transform: uppercase;">
                                                Dados da leitura
                                            </th>
                                        </tr>
                                        <tr v-if="leituraData && siloSelecionado">
                                            <th colspan="2">Data:</th>
                                            <th colspan="3">{{ leituraData.data}}</th>
                                            <th colspan="2">Média:</th>
                                            <th colspan="2">{{ siloSelecionado.media_atual }} ºC</th>
                                            <th colspan="2">Produto:</th>
                                            <th colspan="2">{{ leituraData.produto }}</th>
                                            <th colspan="2">Nível:</th>
                                            <th colspan="2">{{ siloSelecionado.tipo_nivel = 1 ? siloSelecionado.nivel_automatico : siloSelecionado.nivel_manual }} %</th>
                                        </tr>
                                        <tr>
                                            <th>Cabo</th>
                                            <th v-for="i in 16" :key="i">S{{i}} (ºC)</th> 
                                        </tr>
                                        <tr v-for="cabo in leituraData.dados" :key="cabo.cabo">
                                            <th>{{ cabo.cabo }}</th>
                                            <th v-for="index in cabo.sensores" :key="index"
                                                :style="{ backgroundColor: mostrarLeituraColorida ? getCorPorTemperatura(cabo.temperaturas[`s${index}`]) : 'white' }">
                                                {{ cabo.temperaturas[`s${index}`] > 99 ? 'OFF' : cabo.temperaturas[`s${index}`] }}
                                            </th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</MainLayout>
</template>

<script>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import MainLayout from '@/components/layouts/MainLayout.vue';
import { useToast } from "vue-toastification";
import LoadingRelatorio from "@/components/ui/App/LoadingRelatorio.vue";
import temperaturaCores from "@/assets/colors.json";

export default {
    components: {
        MainLayout,
        LoadingRelatorio,
    },

    setup() {
        const unidade = ref({});
        const store = useStore();
        const silos = ref([]);
        const leituraData = ref([]);
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];
        const dataInicio = ref(formattedDate);
        const dataFinal = ref(formattedDate);
        const loadingDados = ref(false);
        const buscandoLeituras = ref(false);
        const selectedSilo = ref(null);
        const selectedSiloNome = ref(null);
        const toast = useToast();
        const leiturasEncontradas = ref([]);
        const selectedLeitura = ref(null);
        const siloSelecionado = ref(null);
        const mostrarLeituraColorida = ref(false);


        const fetchLeiturasBySilo = async () => {
            if (!selectedSilo.value) {
                toast.warning('Selecione um silo antes de buscar as leituras.');
                return;
            }
            try {
                buscandoLeituras.value = true;
                leiturasEncontradas.value = 0;
                const data_inicio = new Date(dataInicio.value + 'T00:00:00');
                const data_final = new Date(dataFinal.value + 'T23:59:59');
                alterarNomeSilo();
                const data = await store.dispatch("leituras/fetchLeiturasBySilo", selectedSilo.value);
                leiturasEncontradas.value = data.filter(leitura => {
                    const dataSplit = leitura.data.split(' ')[0].split('/');
                    const leituraData = new Date(`${dataSplit[2]}-${dataSplit[1]}-${dataSplit[0]}T00:00:00`);
                    return leituraData >= data_inicio && leituraData <= data_final;
                });
                buscandoLeituras.value = false;

                if (leiturasEncontradas.value.length > 0) {
                    selectedLeitura.value = leiturasEncontradas.value[0]._id;
                } else {
                    toast.info('Nenhuma leitura encontrada para o período selecionado.');
                }
            } catch (error) {
                console.error("Erro ao buscar leituras:", error);
                toast.error('Erro ao buscar leituras');
            }
        };

        const gerarRelatorio = async () => {
            if (!selectedLeitura.value) {
                toast.warning('Selecione uma leitura antes de gerar o relatório.');
                return;
            }
            try {
                siloSelecionado.value = silos.value.find(s => s.id === selectedSilo.value);
                loadingDados.value = true;
                const body = {
                    "siloId": selectedSilo.value,
                    "leituraId": selectedLeitura.value
                };
                const response = await store.dispatch("leituras/fetchLeituraById", body);
                loadingDados.value = false;
                leituraData.value = response;
            } catch (error) {
                console.error("Erro ao buscar dados de termometria:", error);
                toast.error('Erro ao buscar dados de termometria');
                loadingDados.value = false;
            }
        };

        const getCorPorTemperatura = (temp) => {
            temp = Number(temp);

            const faixas = Object.keys(temperaturaCores)
                .map(Number)
                .sort((a, b) => a - b);            

            for (let i = 0; i <= faixas.length - 1; i++) {
                if (temp <= faixas[i]) {
                    return temperaturaCores[faixas[i]];
                }
            }

            return "#c31313";
        };

        const alterarNomeSilo = () => {
            selectedSiloNome.value = silos.value.find((s) => s.id === selectedSilo.value)?.nome;
            leituraData.value = null;
        };

        watch(() => store.state.silos.silos, (newSilos) => {
            silos.value = newSilos;
            },{ immediate: true }
        );

        watch(() => store.state.unidade.unidade, (newUnidade) => {
            unidade.value = newUnidade;
            },{ immediate: true }
        );

        return {
            silos,
            unidade,
            dataInicio,
            dataFinal,
            selectedSilo,
            loadingDados,
            LoadingRelatorio,
            selectedSiloNome,
            gerarRelatorio,
            leiturasEncontradas,
            selectedLeitura,
            fetchLeiturasBySilo,
            leituraData,
            alterarNomeSilo,
            siloSelecionado,        
            mostrarLeituraColorida,
            buscandoLeituras,
            getCorPorTemperatura
        };
    },
}
</script>

<style scoped>
table {
  width: 100%;
  text-align: center;
}

thead th {
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
  padding: 12px;
  border-bottom: 2px solid #dee2e6;
}

tbody th {
  background-color: #e9ecef;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  border-bottom: 2px solid #dee2e6;
}

tbody td {
  text-align: center;
  padding: 10px;
  vertical-align: middle;
}

tbody ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}

tbody ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.header-table {
  width: 100%;
  text-align: center;
  margin-bottom: 1rem;
}

.title-pdf,
.header-unidade {
  word-wrap: break-word;
  text-align: center;
  box-sizing: border-box;
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 700;
  line-height: 1.2;
  font-size: 1.3rem;
}

.btn-view-relatorio {
  background-color: #1c1c1c;
  color: white;
  border: 1px solid black;
}

.btn-view-relatorio:hover {
  background-color: grey;
  color: #1c1c1c;
  border: 1px solid black;
}
</style>
